import React from "react";
import { Grid, Box } from "@mui/material";
import { Copyright } from "@mui/icons-material";

import { ParagraphTextPage } from "components/cardBodyStyle";

export default function Footer(props) {
  return (
    <footer className="footer" style={{ background: "#fff", padding: 10 }}>
      <Grid container>
        <Grid item xs="12" md="12">
          <Box sx={{ mt: 1 }}>
            <center>
              <ParagraphTextPage
                style={{
                  fontSize: 12,
                }}
              >
                Todos los derechos reservados - BookNPAY parte del grupo Vive
                Tech Ecuador S.A.S, Copyright <Copyright />{" "}
                {1900 + new Date().getYear()}
              </ParagraphTextPage>
            </center>
          </Box>
        </Grid>
      </Grid>
    </footer>
  );
}
